var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg20Gold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 97.7095 60.4351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 6.4351px;\n      }\n\n      .cls-2 {\n        fill: url(#Gold);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gold",
    x1: 48.85475,
    y1: 8.31469,
    x2: 48.85475,
    y2: 45.28912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00562,
    stopColor: "#fccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25281,
    stopColor: "#fffad2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29822,
    stopColor: "#faf1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38847,
    stopColor: "#edd894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51382,
    stopColor: "#d8b14c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59551,
    stopColor: "#c9961a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81418,
    stopColor: "#e9cd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87079,
    stopColor: "#f2dc8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffad2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "draw"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.38426,47.25619c-.824,5.91664-5.24266,9.51125-11.15931,9.51125-6.89071,0-16.702-4.94259-20.07276-4.94259-2.47129,0-2.92062,1.79731-3.29532,4.194H3.21755V54.59544c0-4.04394,1.648-11.384,5.842-15.35328,5.91665-5.692,19.99735-10.93464,19.99735-20.82138,0-5.24265-3.29532-8.01323-8.23868-8.01323-1.87272,0-5.99128.52395-6.8153,2.696a4.81847,4.81847,0,0,1,3.9693,5.09262c0,3.74543-2.69595,6.21672-6.44138,6.21672-4.71792,0-7.93861-3.37073-7.93861-8.08865,0-10.56072,12.882-13.10664,20.97063-13.10664,9.7367,0,20.37205,3.59461,20.37205,14.97857,0,6.516-4.41942,11.75867-10.1114,14.45541C16.99818,41.03947,12.28026,44.33478,12.28026,47.40544c2.62133-2.32126,4.49326-3.52,7.93861-3.52a80.76677,80.76677,0,0,1,13.33131,1.498c2.47208,0,4.41942-.44932,4.56867-3.07065l.30007-4.344h6.96534ZM73.59594,3.21755c16.402,0,20.896,12.58191,20.896,26.438,0,16.77666-4.94337,27.56205-22.01932,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C51.65125,15.05084,56.74466,3.21755,73.59594,3.21755ZM67.3046,22.98945V40.06619c0,3.67.74861,9.51125,5.692,9.51125,4.26938,0,5.7674-3.44457,5.7674-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07463-12.05874-5.61657-12.05874C68.65258,11.00612,67.3046,14.15219,67.3046,22.98945Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.38426,47.25619c-.824,5.91664-5.24266,9.51125-11.15931,9.51125-6.89071,0-16.702-4.94259-20.07276-4.94259-2.47129,0-2.92062,1.79731-3.29532,4.194H3.21755V54.59544c0-4.04394,1.648-11.384,5.842-15.35328,5.91665-5.692,19.99735-10.93464,19.99735-20.82138,0-5.24265-3.29532-8.01323-8.23868-8.01323-1.87272,0-5.99128.52395-6.8153,2.696a4.81847,4.81847,0,0,1,3.9693,5.09262c0,3.74543-2.69595,6.21672-6.44138,6.21672-4.71792,0-7.93861-3.37073-7.93861-8.08865,0-10.56072,12.882-13.10664,20.97063-13.10664,9.7367,0,20.37205,3.59461,20.37205,14.97857,0,6.516-4.41942,11.75867-10.1114,14.45541C16.99818,41.03947,12.28026,44.33478,12.28026,47.40544c2.62133-2.32126,4.49326-3.52,7.93861-3.52a80.76677,80.76677,0,0,1,13.33131,1.498c2.47208,0,4.41942-.44932,4.56867-3.07065l.30007-4.344h6.96534ZM73.59594,3.21755c16.402,0,20.896,12.58191,20.896,26.438,0,16.77666-4.94337,27.56205-22.01932,27.56205-18.49934,0-20.82138-16.028-20.82138-28.31066C51.65125,15.05084,56.74466,3.21755,73.59594,3.21755ZM67.3046,22.98945V40.06619c0,3.67.74861,9.51125,5.692,9.51125,4.26938,0,5.7674-3.44457,5.7674-9.212,0-6.66526.14925-11.75867.14925-17.30062,0-4.194-.07463-12.05874-5.61657-12.05874C68.65258,11.00612,67.3046,14.15219,67.3046,22.98945Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Gold);
export default __webpack_public_path__ + "static/media/20-gold.9a242b350422bc925a32fc6486c7b692.svg";
export { ForwardRef as ReactComponent };